import styled from 'styled-components';

import { inputStyling } from '../helpers.new';

export const Select = styled.select`
    ${(props) => inputStyling(props)}

    /* Already seems to have some padding so use lower value to make it look consistent with inputs */
    padding: 5px;

    /* Matches the text input's disabled/read-only treatment (Input.styles.tsx's &:read-only) for consistency. */
    &[disabled] {
        cursor: not-allowed;
        border: none;
        opacity: 0.4;
    }

    /* Use min-content for narrow width version instead */
    ${({ narrowWidth }) => (narrowWidth ? `width: min-content;` : '')}
`;

Select.displayName = 'Select';

export const Option = styled.option``;

Option.displayName = 'Option';
